<template>
  <div class="worker-knowledge-types">
    <a-card title="Worker配置的知识" size="small">
      <div v-if="configKnowledge && configKnowledge.knowledge_details">
        <a-list v-if="groupedKnowledge.length > 0" size="small">
          <template v-for="group in groupedKnowledge" :key="group.type">
            <a-list-item>
              <a-typography-title :level="5" style="margin: 0">{{ group.typeName }}</a-typography-title>
            </a-list-item>
            <a-list-item 
              v-for="item in group.items" 
              :key="item.id"
              style="padding-left: 24px"
            >
              <div style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
                <span>{{ item.title }}</span>
                <a 
                  href="#" 
                  @click.stop="handleOpenKnowledge(item.id)"
                  style="font-size: 12px;"
                >查看</a>
              </div>
            </a-list-item>
          </template>
        </a-list>
        <div v-else style="color: #999; text-align: center; padding: 16px">
          该Worker未配置知识
        </div>
      </div>
      <div v-else-if="knowledgeTypesList && knowledgeTypesList.length > 0" style="color: #999; font-size: 12px; padding: 8px;">
        <div>配置的知识类型：</div>
        <a-list size="small">
          <a-list-item v-for="type in knowledgeTypesList" :key="type.type_code">
            {{ type.type_name }} ({{ type.type_code }})
          </a-list-item>
        </a-list>
      </div>
      <div v-else style="color: #999; text-align: center; padding: 16px">
        该Worker未配置知识
      </div>
    </a-card>
  </div>
</template>

<script>
import { computed } from 'vue';
import { useRouter } from 'vue-router';

const TYPE_NAMES = {
  prompt: '提示词',
  dataflow: '数据流',
  pin_info: '针脚信息',
  case: '典型案例',
  principle: '系统原理'
};

export default {
  name: 'WorkerKnowledgeTypes',
  props: {
    knowledgeTypes: {
      type: Array,
      default: () => []
    },
    configKnowledge: {
      type: Object,
      default: null
    }
  },
  setup(props) {
    const router = useRouter();
    const knowledgeTypesList = computed(() => {
      return Array.isArray(props.knowledgeTypes) ? props.knowledgeTypes : [];
    });

    const groupedKnowledge = computed(() => {
      if (!props.configKnowledge || !props.configKnowledge.knowledge_details) {
        return [];
      }

      const groups = {};
      const knowledgeDetails = props.configKnowledge.knowledge_details;

      for (const [typeCode, knowledgeList] of Object.entries(knowledgeDetails)) {
        if (!Array.isArray(knowledgeList) || knowledgeList.length === 0) {
          continue;
        }

        if (!groups[typeCode]) {
          groups[typeCode] = {
            type: typeCode,
            typeName: TYPE_NAMES[typeCode] || typeCode,
            items: []
          };
        }

        knowledgeList.forEach(k => {
          if (k && k.id) {
            groups[typeCode].items.push({
              ...k,
              type_code: typeCode
            });
          }
        });
      }

      return Object.values(groups);
    });

    const handleOpenKnowledge = (knowledgeId) => {
      const routeData = router.resolve({ name: 'knowledge-edit', params: { id: knowledgeId } });
      window.open(routeData.href, '_blank');
    };

    return {
      knowledgeTypesList,
      groupedKnowledge,
      handleOpenKnowledge
    };
  }
};
</script>

<style scoped>
.worker-knowledge-types {
  margin-bottom: 16px;
}
</style>

